// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
/* rtl:begin:ignore */
button.carousel-arrow-module__button___j01iA.carousel-arrow-module__important___jhtK1:focus {
  outline: var(--green300, #2b8000) solid 2px;
  outline-offset: 3px;
}
button.carousel-arrow-module__button___j01iA.carousel-arrow-module__important___jhtK1:focus {
  outline-offset: -1px;
}

.carousel-arrow-module__button___j01iA {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  padding: 0;
  border-width: 0;
  background: var(--surface1, #fff);
  box-shadow: 0 2px 12px 0 rgba(32, 32, 32, 0.25);
  font-size: 1.5rem;
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.carousel-arrow-module__button--left___eUo8V {
  padding-right: 6px;
  padding-top: 4px;
  left: 0;
}
.carousel-arrow-module__button--right___PUjXJ {
  padding-left: 6px;
  padding-top: 4px;
  right: 0;
}
.carousel-arrow-module__button--right___PUjXJ svg {
  transform: rotate(-180deg);
}
.carousel-arrow-module__button___j01iA svg {
  stroke: var(--neutral75, #424547);
  width: 40px;
  height: 40px;
}

/* rtl:end:ignore */`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/modal-templates/templates/carousel-modal-comp/carousel-arrow.module.scss","data:;charset=utf-8,@use%20'../functions/color'%20as%20*;%0A%0A@mixin%20focus-outline($color:%20color(focus),%20$applyDirectly:%20false)%20%7B%0A%20%20@if%20$applyDirectly%20%7B%0A%20%20%20%20outline:%20$color%20solid%202px;%0A%20%20%20%20outline-offset:%203px;%0A%20%20%7D%20@else%20%7B%0A%20%20%20%20&:focus%20%7B%0A%20%20%20%20%20%20outline:%20$color%20solid%202px;%0A%20%20%20%20%20%20outline-offset:%203px;%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D%0A"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACCA,qBAAA;ACMI;EACE,2CAAA;EACA,mBAAA;ADEN;AALE;EACE,oBAAA;AAOJ;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iCAAA;EACA,+CAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAMF;AAJE;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;AAMJ;AAHE;EACE,iBAAA;EACA,gBAAA;EACA,QAAA;AAKJ;AAHI;EACE,0BAAA;AAKN;AADE;EACE,iCAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AAAA,mBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `carousel-arrow-module__button___j01iA`,
	"important": `carousel-arrow-module__important___jhtK1`,
	"button--left": `carousel-arrow-module__button--left___eUo8V`,
	"button--right": `carousel-arrow-module__button--right___PUjXJ`
};
export default ___CSS_LOADER_EXPORT___;
